import axios from 'axios';
import apiConfig from '../../api.config';

export default function registerPaperlessRequest({ email, password, hotelSlug, ownerId, type }) {
  const {
    host,
    URIs: { auth },
  } = apiConfig;

  const uri = `${host}${auth.registerPaperless}`;

  return axios
    .post(uri, JSON.stringify({ email, password, hotelSlug, ownerId, type }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
